import { ComponentProps } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';

import { Checkbox } from '@/components/core/checkbox';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/core/form';

import { FormFieldProps } from './default-form-field';

type CheckboxProps = Omit<ComponentProps<typeof Checkbox>, 'checked' | 'onCheckedChange' | 'name'>;

export function CheckboxFormField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  control,
  name,
  disabled,
  label,
  description,
  hideError,
  ...checkboxProps
}: FormFieldProps<CheckboxProps, TFieldValues, TName>) {
  return (
    <FormField
      control={control}
      name={name}
      disabled={disabled}
      render={({ field }) => (
        <FormItem className="grid grid-cols-[auto_1fr] gap-x-2 gap-y-2">
          <FormControl>
            <Checkbox
              {...checkboxProps}
              checked={field.value ?? false}
              onCheckedChange={(checked) => field.onChange(checked === true)}
              disabled={field.disabled}
            />
          </FormControl>
          {label && <FormLabel className="font-normal">{label}</FormLabel>}
          {description && <FormDescription className="col-start-2">{description}</FormDescription>}
          {!hideError && <FormMessage className="col-start-2" />}
        </FormItem>
      )}
    />
  );
}
